import { render, staticRenderFns } from "./earnest-money-initial.vue?vue&type=template&id=064e79a8"
import script from "./earnest-money-initial.vue?vue&type=script&lang=js"
export * from "./earnest-money-initial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports